<div *transloco="let t; prefix: 'shared.calculations.excludedCalculations'">
  <div mat-dialog-title>
    <p>
      {{ t('title') }}
    </p>
    <button mat-icon-button mat-dialog-close disableRipple (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div mat-dialog-content class="dialog-content">
      @if (
        data.numberOfUnauthorizedCalculations &&
        data.numberOfUnauthorizedCalculations !== 0
      ) {
        <p class="mb-4 text-justify">
          {{
            t('dialog.content.calculations', {
              number: data.numberOfUnauthorizedCalculations,
            })
          }}
        </p>
      }
      @if (data.missingCostRoles && data.missingCostRoles.length > 0) {
        <p class="mb-4 text-justify">
          {{
            t('dialog.content.costRoles', {
              costRoleType: formatMissingCostRoles(data.missingCostRoles),
            })
          }}
        </p>
      }
      @if (data.unauthorizedPlants && data.unauthorizedPlants.length > 0) {
        <p class="mb-4 text-justify">
          {{
            t('dialog.content.unauthorizedPlants', {
              plants: data.unauthorizedPlants,
            })
          }}
        </p>
      }
      <div
        [innerHTML]="
          t('dialog.content.outro', { urlRoleAssignments: urlRoleAssignments })
        "
        class="mb-4"
      ></div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div>
      <a
        mat-flat-button
        color="primary"
        class="!mr-4"
        [href]="urlSams"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ t('dialog.action.sams') }}
      </a>
    </div>
  </mat-dialog-actions>
</div>
